/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unused-vars, no-console */
import { Button, Select, Tooltip } from '@gerdau/hefesto';
import { TableRowSelection } from 'antd/lib/table/interface';
import { driver } from 'driver.js';
import React, { useEffect, useMemo, useState, useRef } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import theme from '../../../../assets/styles/theme/theme';
import Table from '../../../../components/Table';
import { ApplicationState } from '../../../../store';
import {
  Billing,
  EOrderType,
  Filters,
  INITIAL_FILTERS,
  IOpenOrdersTableDataSource,
  SalesOrderItem,
  SalesOrderItemTable
} from '../../../../store/ducks/new-long-steel-orders/types';
import { addToast } from '../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../store/ducks/toast/types';
import {
  ECustomerTypeView,
  EUserPreferenceType,
  IOrderViewPreference,
  ISaveUser,
  orderViewPreferenceDefault
} from '../../../../store/ducks/user/types';
import {
  MessageWithoutEmitter,
  OrdersTableContainer,
  TableCell,
  TableContainer,
  TableHeaderActionButton,
  TableHeaderContainer,
  TableHeaderContainerButtons,
  TableHeaderRightActions,
  TableOrderEmitterDescription,
  TableOrderNumberSelectable
} from './styles';

import { Icon } from '@gerdau/hefesto';
import { InformationPanel } from '@gerdau/hefesto-mais-web';
import { TPanelOptions } from '@gerdau/hefesto-mais-web/InformationPanel/InformationPanel.types';
import { SearchField } from '@gerdau/hefesto/SearchField';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { ENewLongSteelOrdersRoutes } from '..';
import EmitterAndReceiverSelector from '../../../../components/EmitterAndReceiverSelector/Facelift';
import { getStatesFromCustomerArray } from '../../../../components/EmitterAndReceiverSelector/Facelift/SoldToView';
import MessageChooseContract from '../../../../components/MessageChooseContract';
import useDebounce from '../../../../hooks/useDebounce';
import { ERoutes } from '../../../../routes';
import { EOrderTab } from '../../../../store/ducks/long-steel-orders/types';
import { convertFilteredOrdersToIOpenOrdersTableDataSource } from '../../../../store/ducks/new-long-steel-orders';
import {
  downloadOrderItems,
  loadXml,
  loadOrderDetail,
  updateOrdersFiltered,
  validationUpdateItems,
  loadNewNFFile,
  loadNewQCFile,
  loadNewShippingNoteFile
} from '../../../../store/ducks/new-long-steel-orders/actions';
import { sendTagging } from '../../../../store/ducks/tagging/actions';
import { finishOnboarding } from '../../../../store/ducks/new-long-steel-onboarding/actions';
import { NewLongSteelOrdersOnboardingSteps } from '../../../../store/ducks/new-long-steel-onboarding/types';
import { saveUser } from '../../../../store/ducks/user/actions';
import { EPurchaseRoutes } from '../../../Purchase/purchase.routes';
import { EOrdersRoutes } from '../../orders.routes';
import OrdersPersonalizeModal, {
  openOrderSections
} from '../OrdersPersonalizeModal';
import {
  ProductionProgressVolumeBar,
  ProgressVolumeBar
} from '../ProgressVolumeBar';
import { HeaderColumnTable } from './HeaderColumnTable';
import { actionsOptions, HeaderColumnProps, SortDirection } from './types';
import DeliveryStatusColumn from './DeliveryStatusColumn';
import { formatNumberWithLocale } from '../../../../utils/formatNumbers';
import { MarketingCloudService } from '../../../../services/MarketingCloud';
import { createXMLTable } from '../../../../utils/createXMLTable';
import ReactDOMServer from 'react-dom/server';
import { OrderTableContentToExcel } from '../OrdersFilters/OrderTableContentToExcel';
import { NewLongSteelOrdersService } from '../../../../services/NewLongSteelOrders';
import { select } from 'redux-saga/effects';
import { Sort } from 'styled-icons/boxicons-regular';
import { TSelectOptionProps } from '@gerdau/hefesto/Select/Select.types';
import { uppercaseOnlyFirstLetter } from '../../../../utils/formatStrings';
import { TMinimalDescribeICustomer } from '../../../../store/ducks/customers/types';

const genericToSuffixMap: { [key: string]: string } = {
  futureDeliveriesDate: '_date',
  futureDeliveriesQuantity: '_quantity',
  futureDeliveriesUnit: '_unit'
};

const keyMappings: { [key: string]: string } = {
  _date: 'futureDeliveriesDate',
  _quantity: 'futureDeliveriesQuantity',
  _unit: 'futureDeliveriesUnit'
};

const getTargetKeyFromMap = (columnKey: string): string => {
  const foundSuffix = Object.keys(keyMappings).find((suffix) =>
    columnKey.includes(suffix)
  );
  return foundSuffix ? keyMappings[foundSuffix] : columnKey;
};

export const flatSteelItems = [
  'meltShop',
  'rollingMill',
  'rollingFinish',
  'finish',
  'stockMill',
  'transit',
  'stockWarehouse',
  'productionStatus'
];

export type materialCodeType = 'sku' | 'customerSKU';
export interface OrderPreferencesProps {
  columnsHidden: string[];
  materialCode: materialCodeType;
}

const createDynamicDeliveryFilters = (
  numberOfDeliveries: number
): { [key: string]: string } => {
  const dynamicFilters: { [key: string]: string } = {};

  for (let i = 0; i < numberOfDeliveries; i++) {
    dynamicFilters[`futureDelivery_${i}_date`] = '';
    dynamicFilters[`futureDelivery_${i}_quantity`] = '';
    dynamicFilters[`futureDelivery_${i}_unit`] = '';
  }

  return dynamicFilters;
};

const orderStatus = [
  {
    label: 'Saldo',
    value: 'balance'
  },
  {
    label: 'Em carregamento',
    value: 'inLoading'
  },
  {
    label: 'Em remessa',
    value: 'inShipment'
  },
  {
    label: 'Faturado',
    value: 'INVOICED'
  }
];

export const OrdersTable = ({
  hasInitialized
}: {
  hasInitialized: boolean;
}) => {
  const maxSelectedRows = 10;
  const dispatch = useDispatch();
  const history = useHistory();

  const driverRef = useRef<any>(null);
  const ordersState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );
  const activeTabState = ordersState[ordersState.tableType || EOrderTab.OPEN];

  const ordersItems = useSelector(
    (state: ApplicationState) =>
      state.newLongSteelOrders[
        state.newLongSteelOrders.tableType || EOrderTab.OPEN
      ].items,
    shallowEqual
  );
  const customersState = useSelector(
    (state: ApplicationState) => state.customers
  );
  const customerViewType = useSelector(
    (state: ApplicationState) => state.user.searchCustomerType
  );
  const user = useSelector((state: ApplicationState) => state.user);
  const orderState = useSelector(
    (state: ApplicationState) => state.newLongSteelOrders
  );
  const isUserAdmin = useSelector(
    (state: ApplicationState) => state.user.isManager
  );

  const [emitterIds, setEmitterIds] = useState<string[]>(
    activeTabState.initialInputValues.emitterIds || []
  );
  const userState = useSelector((state: ApplicationState) => state.user);
  const customers = useSelector((state: ApplicationState) =>
    state.customers.customers.filter((customer) =>
      userState.roles.ordersViewCustomers.includes(customer.customerId)
    )
  );
  const [receiverIds, setReceiverIds] = useState(
    customers.map((customer) => customer.customerId)
  );
  const [selectedStates, setSelectedStates] = useState<string[]>(
    activeTabState.initialInputValues.states.length === 0
      ? getStatesFromCustomerArray(customers).map((item) => item.value)
      : activeTabState.initialInputValues.states
  );

  const getUserOrderOrderPreference = (): OrderPreferencesProps => {
    const orderEntryIdx = user.preferences.findIndex(
      (preference) => preference.name === EUserPreferenceType.ORDER_VIEW
    );

    const hasPreferences = user.preferences[
      orderEntryIdx
    ] as IOrderViewPreference;

    if (orderEntryIdx !== -1 && hasPreferences && hasPreferences.toggles) {
      const columnsHidden = hasPreferences.toggles
        .filter((item) => !item.checked)
        .map((item) => item.value);

      let materialCode: materialCodeType = hasPreferences.toggles.find(
        (item) => item.value === 'chipState_customerSKU' && item.checked
      )
        ? 'customerSKU'
        : 'sku';

      if (
        !hasPreferences.toggles.some(
          (item) => item.value === 'chipState_customerSKU'
        )
      ) {
        materialCode = hasPreferences.toggles.find(
          (item) => item.value === 'customerSKU' && item.checked
        )
          ? 'customerSKU'
          : 'sku';
      }

      return {
        columnsHidden,
        materialCode
      };
    }

    const columnsHidden = orderViewPreferenceDefault.toggles
      .filter((item) => !item.checked)
      .map((item) => item.value);

    const materialCode: materialCodeType =
      orderViewPreferenceDefault.toggles.find(
        (item) => item.value === 'customerSKU' && item.checked
      )
        ? 'customerSKU'
        : 'sku';

    return {
      columnsHidden,
      materialCode
    };
  };

  const [openOrdersData, setOpenOrdersData] = useState<SalesOrderItemTable[]>(
    []
  );
  const [orderedSales, setOrderedSales] = useState<SalesOrderItemTable[]>([]);

  const { step: onboardingStep } = useSelector(
    (state: ApplicationState) => state.newLongSteelOnboarding
  );

  const onboardingPreference = userState.preferences.find(
    (p) => p.name === EUserPreferenceType.ORDER_ONBOARDING
  );

  useEffect(() => {
    const isHidden = onboardingPreference?.preferenceItems?.includes('hidden');

    if (
      onboardingStep === NewLongSteelOrdersOnboardingSteps.NEXT_STEP &&
      !isHidden &&
      hasInitialized &&
      orderedSales.length > 0
    ) {
      const startTour = () => {
        const element = document.querySelector('#onboarding-download-xls');
        if (!element) return;

        const driverObj = driver({
          allowClose: false,
          showProgress: false,
          nextBtnText: 'Avançar',
          prevBtnText: 'Voltar',
          doneBtnText: 'Fechar',
          overlayColor: '#192D3880',
          overlayClickBehavior: () => null,
          onNextClick: (elem: any, step: any, options: any) => {
            const activeStep = (options.state.activeIndex ?? 0) + 3;
            const isCompleted = user.preferences
              .find((p) => p.name === EUserPreferenceType.ORDER_ONBOARDING)
              ?.preferenceItems?.includes('completed');

            const startTime =
              localStorage.getItem('@long-steel-orders-onboarding-time') ?? 0;

            const usedTime = Math.abs(Date.now() - Number(startTime)) / 1000;

            if (driverObj.isLastStep()) {
              dispatch(
                sendTagging({
                  event: 'onboarding_completed',
                  onboarding_name: 'pedidos_acos_longos',
                  onboarding_version: 'v1',
                  step_id: activeStep,
                  step_name: 'pos_carregamento',
                  next_step_id: activeStep + 1,
                  progress_percentage: (activeStep / 5) * 100,
                  screen_state: 'post_table_load',
                  step_context: isCompleted
                    ? 'fluxo_ja_realizado'
                    : 'primeiro_acesso',
                  user_access_type: isCompleted
                    ? 'already_accessed'
                    : 'first_access',
                  hide_tips_selected: false,
                  interaction_type: 'botao_fechar',
                  total_steps: activeStep,
                  completed_from: true,
                  completion_time_seconds: usedTime
                })
              );
            } else {
              dispatch(
                sendTagging({
                  event: 'onboarding_next_step',
                  onboarding_name: 'pedidos_acos_longos',
                  onboarding_version: 'v1',
                  step_id: activeStep,
                  step_name: 'pos_carregamento',
                  next_step_id: activeStep + 1,
                  progress_percentage: (activeStep / 5) * 100,
                  screen_state: 'post_table_load',
                  step_context: isCompleted
                    ? 'fluxo_ja_realizado'
                    : 'primeiro_acesso',
                  user_access_type: isCompleted
                    ? 'already_accessed'
                    : 'first_access',
                  interaction_type: 'botao_avancar'
                })
              );
            }

            if (driverObj) {
              driverObj.moveNext();
            }
          },
          onPopoverRender: (popover) => {
            const isCompleted = user.preferences
              .find((p) => p.name === EUserPreferenceType.ORDER_ONBOARDING)
              ?.preferenceItems?.includes('completed');

            const stepIndicator = document.createElement('div');
            const activeStep = (driverObj.getActiveIndex() ?? 0) + 3;

            stepIndicator.innerText = `${activeStep} de 5 dicas`;
            stepIndicator.style.color = theme.colors.grayDark4;
            stepIndicator.style.fontSize = '14px';
            stepIndicator.style.lineHeight = '22px';
            stepIndicator.style.fontWeight = '400';
            stepIndicator.style.marginBottom = '8px';
            stepIndicator.style.fontFamily = theme.fonts.workSans;

            popover.title.parentElement?.prepend(stepIndicator);

            popover.wrapper.style.width = '448px';
            popover.wrapper.style.maxWidth = '448px';

            popover.title.style.color = theme.colors.grayDark3;
            popover.title.style.fontSize = '16px';
            popover.title.style.fontWeight = '600';
            popover.title.style.lineHeight = '24px';
            popover.title.style.fontFamily = theme.fonts.openSans;

            popover.description.style.color = theme.colors.grayDark4;
            popover.description.style.fontSize = '16px';
            popover.description.style.fontWeight = '400';
            popover.description.style.lineHeight = '24px';
            popover.description.style.marginTop = '8px';
            popover.description.style.marginBottom = '20px';
            popover.description.style.fontFamily = theme.fonts.workSans;

            const nextBtn = popover.nextButton;
            const prevBtn = popover.previousButton;

            [nextBtn, prevBtn].forEach((btn) => {
              if (btn) {
                btn.style.background = 'transparent';
                btn.style.border = 'none';
                btn.style.color = theme.colors.darkBlue2;
                btn.style.fontWeight = '400';
                btn.style.fontSize = '16px';
                btn.style.boxShadow = 'none';
                btn.style.textShadow = 'none';
                btn.style.fontFamily = theme.fonts.workSans;

                if (btn.disabled) {
                  btn.style.fontFamily = theme.fonts.workSans;
                  btn.style.color = theme.colors.darkBlue2;
                  btn.style.opacity = '36%';
                }
              }
            });

            if (isCompleted) {
              const footer = popover.footer;
              const hideTipsBtn = document.createElement('button');
              hideTipsBtn.innerText = 'Ocultar dicas';
              hideTipsBtn.style.background = 'transparent';
              hideTipsBtn.style.border = 'none';
              hideTipsBtn.style.color = theme.colors.darkBlue2;
              hideTipsBtn.style.fontSize = '16px';
              hideTipsBtn.style.fontWeight = '400';
              hideTipsBtn.style.fontFamily = theme.fonts.workSans;
              hideTipsBtn.style.cursor = 'pointer';
              hideTipsBtn.style.marginRight = 'auto';
              hideTipsBtn.style.padding = '0';

              hideTipsBtn.onmousedown = (e) => {
                e.preventDefault();
                e.stopPropagation();
                dispatch(
                  sendTagging({
                    event: 'onboarding_closed',
                    onboarding_name: 'pedidos_acos_longos',
                    onboarding_version: 'v1',
                    step_id: activeStep,
                    step_name: 'pos_carregamento',
                    progress_percentage: (activeStep / 5) * 100,
                    screen_state: 'post_table_load',
                    user_access_type: isCompleted
                      ? 'already_accessed'
                      : 'first_access',
                    interaction_type: 'botao_ocultar',
                    hide_tips_selected: true,
                    close_type: 'botao_ocultar_dicas'
                  })
                );
                dispatch(
                  saveUser({
                    user,
                    userPreference: {
                      name: EUserPreferenceType.ORDER_ONBOARDING,
                      preferenceItems: ['hidden']
                    }
                  })
                );
                driverObj.destroy();
              };

              footer.prepend(hideTipsBtn);
            }
          },
          steps: [
            {
              element: '#onboarding-download-xls',
              popover: {
                title: 'Baixe todos os dados em Excel',
                description:
                  'Exporte todos os dados dos seus pedidos para uma planilha do Excel e faça suas próprias análises.',
                side: 'bottom',
                align: 'end'
              }
            },
            {
              element: '#onboarding-first-ov',
              popover: {
                title: 'Detalhe das ordens de venda',
                description:
                  'Acesse todos os produtos da sua ordem de venda e consulte todas as datas estimadas se necessário.',
                side: 'bottom',
                align: 'start'
              }
            },
            {
              element: '#onboarding-personalize-table',
              popover: {
                title: 'Personalize sua tabela de pedidos',
                description:
                  'Oculte colunas, adicione novas e modifique os códigos de materiais deixando a tabela do seu jeito.',
                side: 'bottom',
                align: 'end'
              }
            }
          ],
          onDestroyed: () => {
            dispatch(finishOnboarding());
            if (
              !user.preferences
                .find((p) => p.name === EUserPreferenceType.ORDER_ONBOARDING)
                ?.preferenceItems?.includes('completed')
            ) {
              dispatch(
                saveUser({
                  user,
                  userPreference: {
                    name: EUserPreferenceType.ORDER_ONBOARDING,
                    preferenceItems: ['completed']
                  }
                })
              );
            }
            driverRef.current = null;
          }
        });

        const isCompletedInit = user.preferences
          .find((p) => p.name === EUserPreferenceType.ORDER_ONBOARDING)
          ?.preferenceItems?.includes('completed');

        dispatch(
          sendTagging({
            event: 'onboarding_view',
            onboarding_name: 'pedidos_acos_longos',
            onboarding_version: 'v1',
            step_id: 3,
            step_name: 'pos_carregamento',
            next_step_id: 4,
            progress_percentage: (3 / 5) * 100,
            screen_state: 'post_table_load',
            step_context: isCompletedInit
              ? 'fluxo_ja_realizado'
              : 'primeiro_acesso',
            user_access_type: isCompletedInit
              ? 'already_accessed'
              : 'first_access'
          })
        );

        driverRef.current = driverObj;
        driverObj.drive();

        return () => {
          driverObj.destroy();
          driverRef.current = null;
        };
      };

      // Pequeno delay para garantir que o Hefesto renderizou o botão no DOM
      const timeoutId = setTimeout(startTour, 500);
      return () => clearTimeout(timeoutId);
    }
    return () => null;
  }, [onboardingStep, hasInitialized, orderedSales.length, dispatch, user]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  useEffect(() => {
    setSelectedRowKeys([]);
  }, [ordersState.tableType]);

  const [query, setQuery] = useState('');
  const [selectedStatusesOpen, setSelectedStatusesOpen] = useState<string[]>(
    orderStatus.map((status) => status.value)
  );

  const [selectedStatusesBilled, setSelectedStatusesBilled] = useState<
    string[]
  >(orderStatus.map((status) => status.value));

  const selectedStatuses =
    ordersState.tableType === EOrderTab.BILLED
      ? selectedStatusesBilled
      : selectedStatusesOpen;

  const [filterOrders, setFilterOrders] = useState(orderedSales);

  const [futureDeliveriesColumnQty, setFutureDeliveriesColumnQty] = useState(0);

  const [orderPreferences, setOrderPreferences] =
    useState<OrderPreferencesProps>(getUserOrderOrderPreference());

  const [filters, setFilters] = useState<Filters>(INITIAL_FILTERS);

  const [modal, setModal] = useState({
    personalizeTable: false,
    sideOptionsDownload: false,
    request: false,
    itemsUnavailable: false,
    confirm: false,
    finish: false
  });

  const activeToggles = useMemo(() => {
    const userPreference = user.preferences.find(
      (preference) => preference.name === EUserPreferenceType.ORDER_VIEW
    ) as IOrderViewPreference | undefined;

    return userPreference?.toggles ?? orderViewPreferenceDefault.toggles;
  }, [user.preferences]);

  const finalHideColumns = useMemo(() => {
    const columnsToHide = new Set<string>(orderPreferences.columnsHidden);

    const uncheckedGenericToggles = activeToggles
      .filter(
        (toggle) =>
          !toggle.checked &&
          Object.keys(genericToSuffixMap).includes(toggle.value)
      )
      .map((toggle) => toggle.value);

    uncheckedGenericToggles.forEach((genericKey) => {
      const suffix = genericToSuffixMap[genericKey];
      if (suffix) {
        for (let i = 0; i < futureDeliveriesColumnQty; i++) {
          columnsToHide.add(`futureDelivery_${i}${suffix}`);
        }
      }
    });

    if (!orderedSales.some((item) => item.orderType === EOrderType.PLANOS)) {
      flatSteelItems.forEach((item) => columnsToHide.add(item));
    }
    if (
      customerViewType === ECustomerTypeView.RECEIVER ||
      customerViewType === ECustomerTypeView.FABRICATION_RECEIVER
    ) {
      columnsToHide.add('emitter');
      columnsToHide.add('receiver');
    }

    return Array.from(columnsToHide);
  }, [
    activeToggles,
    orderPreferences.columnsHidden,
    futureDeliveriesColumnQty,
    orderedSales,
    customerViewType
  ]);

  const handleInputChange = ({
    column,
    value
  }: {
    column: keyof IOpenOrdersTableDataSource;
    value: unknown;
  }) => {
    const updatedFilters = {
      ...filters,
      [column]: value
    };

    setFilters(updatedFilters);
    filterData(updatedFilters);

    if (value) {
      dispatch(
        sendTagging({
          event: 'busca_por_coluna',
          termo_buscado: value,
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos',
          estado_emissor: activeTabState.initialInputValues.states.join(', '),
          emissor_pedido: customersState.customers
            .filter((item) =>
              activeTabState.initialInputValues.emitterIds.includes(
                item.customerId
              )
            )
            .map((item) => item.name)
            .join(', '),
          data_inicio:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(activeTabState.initialInputValues.startDate).format(
                  'DD/MM/YYYY'
                ),
          data_fim:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(activeTabState.initialInputValues.endDate).format(
                  'DD/MM/YYYY'
                )
        })
      );
    }
  };

  const applyAllFilters = (
    currentOrders: SalesOrderItemTable[],
    currentFilters: Filters,
    currentQuery: string,
    currentReceivers: string[],
    currentStatuses: string[]
  ) => {
    let result = currentOrders;

    result = result.filter((item: Filters) => {
      return Object.entries(currentFilters).every(([key, value]) => {
        if (!value || typeof value !== 'string') return true;

        const itemValue = item[key as keyof Filters];

        if (itemValue === null || itemValue === undefined) {
          return false;
        }

        return String(itemValue)
          .toLowerCase()
          .includes(String(value).toLowerCase());
      });
    });

    if (currentQuery.trim()) {
      const q = currentQuery.toLowerCase().trim();
      result = result.filter((item) => {
        const materialDesc =
          (ordersState.tableType === EOrderTab.OPEN
            ? item.materialDescription
            : item.billingHistory?.materialDescription) ?? '';

        const sku =
          (ordersState.tableType === EOrderTab.OPEN
            ? item.sku
            : item.billingHistory?.sku) ?? '';

        const customerSKU =
          (ordersState.tableType === EOrderTab.OPEN
            ? item.customerSKU
            : item.billingHistory?.customerSKU) ?? '';

        const divDesc = item.divisionDescription ?? '';
        const id = item.id ?? '';
        const orderNum = item.salesOrder ?? '';
        const invoiceNum = item.invoiceNumber ?? '';
        const danfeNum = item.danfeNumber ?? '';
        const customerOrd = item.customerOrder ?? '';

        return (
          String(divDesc).toLowerCase().includes(q) ||
          String(sku).toLowerCase().includes(q) ||
          String(customerSKU).toLowerCase().includes(q) ||
          String(materialDesc).toLowerCase().includes(q) ||
          String(id).toLowerCase().includes(q) ||
          String(orderNum).toLowerCase().includes(q) ||
          String(invoiceNum).toLowerCase().includes(q) ||
          String(danfeNum).toLowerCase().includes(q) ||
          String(customerOrd).toLowerCase().includes(q)
        );
      });
    }

    if (currentReceivers.length > 0) {
      result = result.filter((item) => {
        const itemReceiverId = item.shipTo?.code;
        const itemEmitterId = item.soldTo?.code;
        if (!itemReceiverId) return true;
        return (
          currentReceivers.includes(itemReceiverId) ||
          currentReceivers.includes(itemEmitterId)
        );
      });
    } else {
      result = [];
    }

    if (currentStatuses.length > 0) {
      result = result.filter((item) => {
        const isBalance =
          item.quantities?.pendingConversionQuantity &&
          Number(item.quantities.pendingConversionQuantity) > 0;
        const isInLoading =
          item.quantities?.shipmentConversionQuantity &&
          Number(item.quantities.shipmentConversionQuantity) > 0;
        const isInShipment =
          item.quantities?.deliveryConversionQuantity &&
          Number(item.quantities.deliveryConversionQuantity) > 0;
        const isBilled =
          item.quantities?.billedConversionQuantity &&
          Number(item.quantities.billedConversionQuantity) > 0;

        if (currentStatuses.includes('balance') && isBalance) return true;
        if (currentStatuses.includes('inLoading') && isInLoading) return true;
        if (currentStatuses.includes('inShipment') && isInShipment) return true;
        if (currentStatuses.includes('INVOICED') && isBilled) return true;

        if (
          ordersState.tableType === EOrderTab.BILLED &&
          currentStatuses.includes('INVOICED') &&
          item.invoiceZvoi
        )
          return true;
        if (
          ordersState.tableType === EOrderTab.BILLED &&
          currentStatuses.includes('INVOICED') &&
          item.billingHistory
        )
          return true;

        return false;
      });
    } else {
      result = [];
    }

    dispatch(
      sendTagging({
        event: 'busca_por_coluna',
        termo_buscado: query,
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor: activeTabState.initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            activeTabState.initialInputValues.emitterIds.includes(
              item.customerId
            )
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(activeTabState.initialInputValues.startDate).format(
                'DD/MM/YYYY'
              ),
        data_fim:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(activeTabState.initialInputValues.endDate).format(
                'DD/MM/YYYY'
              )
      })
    );

    setFilterOrders(result);
    return result;
  };

  const filterData = (filtersToApply: Filters) => {
    const result = applyAllFilters(
      orderedSales,
      filtersToApply,
      query,
      receiverIds,
      selectedStatuses
    );
  };

  useEffect(() => {
    if (orderedSales.length > 0) {
      const result = applyAllFilters(
        orderedSales,
        filters,
        query,
        receiverIds,
        selectedStatuses
      );
    }
  }, [orderedSales, filters, query, selectedStatuses, receiverIds]);

  const loadingState = customersState.loading || ordersState.loading;

  const debounceFilter = useDebounce(handleInputChange, 500);
  const debounceSavePreferences = useDebounce(
    (e: OrderPreferencesProps) => handleUpdatePreferences(e),
    300
  );

  const sortOpenOrders = (openOrders: SalesOrderItemTable[]) => {
    return openOrders.sort((current, next) => {
      return current.creationDate > next.creationDate
        ? -1
        : current.creationDate < next.creationDate
        ? 1
        : 0;
    });
  };

  useEffect(() => {
    const custIds = Array.from(
      new Set([
        ...customers.map((item) => item.customerId),
        ...filterOrders.map((it) => it.shipTo.code)
      ])
    );
    setReceiverIds(custIds);

    const orders: SalesOrderItemTable[] =
      convertFilteredOrdersToIOpenOrdersTableDataSource(
        ordersItems as SalesOrderItem[]
      );
    const sortData = sortOpenOrders(orders);
    setOpenOrdersData(sortData);
    setOrderedSales(sortData);
    setFilterOrders(sortData);

    const futureDeliveryQty = sortData.reduce((maxCount, order) => {
      const currentLength = order.futureDeliveries?.length ?? 0;
      return Math.max(maxCount, currentLength);
    }, 0);

    if (futureDeliveryQty > 0) {
      const dynamicFilters = createDynamicDeliveryFilters(futureDeliveryQty);

      setFutureDeliveriesColumnQty(futureDeliveryQty);
      setFilters({ ...INITIAL_FILTERS, ...dynamicFilters });
    } else {
      setFutureDeliveriesColumnQty(0);
      setFilters(INITIAL_FILTERS);
    }
    dispatch(updateOrdersFiltered({ orders: sortData }));
    if (sortData && sortData.length > 0) {
      dispatch(
        sendTagging({
          event: 'tabela_carregada',
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos',
          estado_emissor: activeTabState.initialInputValues.states.join(', '),
          emissor_pedido: customersState.customers
            .filter((item) =>
              activeTabState.initialInputValues.emitterIds.includes(
                item.customerId
              )
            )
            .map((item) => item.name)
            .join(', '),
          data_inicio:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(activeTabState.initialInputValues.startDate).format(
                  'DD/MM/YYYY'
                ),
          data_fim:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(activeTabState.initialInputValues.endDate).format(
                  'DD/MM/YYYY'
                )
        })
      );
    }
  }, [ordersItems]);

  const handleSort = (
    key: keyof IOpenOrdersTableDataSource,
    direction: SortDirection,
    parser?: (val: unknown) => any
  ) => {
    if (key === 'emissor') {
      dispatch(
        sendTagging({
          event: 'click_emissor',
          click_ordenar:
            direction === 'asc' ? 'ordenar crescente' : 'ordenar decrescente',
          screenName: 'LG:MeusPedidos'
        })
      );
    }

    const sorted = [...openOrdersData].sort((a, b) => {
      let valA = a[key];
      let valB = b[key];

      if (!parser) {
        if (valA == null) return direction === 'asc' ? -1 : 1;
        if (valB == null) return direction === 'asc' ? 1 : -1;
      }

      if (parser) {
        valA = parser(valA);
        valB = parser(valB);
      }

      if (valA instanceof Date && isNaN(valA.getTime())) valA = null;
      if (valB instanceof Date && isNaN(valB.getTime())) valB = null;

      if (valA == null && valB == null) return 0;
      if (valA == null) return 1;
      if (valB == null) return -1;

      if (valA instanceof Date && valB instanceof Date) {
        return direction === 'asc'
          ? valA.getTime() - valB.getTime()
          : valB.getTime() - valA.getTime();
      }

      if (typeof valA === 'number' && typeof valB === 'number') {
        return direction === 'asc' ? valA - valB : valB - valA;
      }

      if (typeof valA === 'boolean' && typeof valB === 'boolean') {
        return direction === 'asc'
          ? Number(valA) - Number(valB)
          : Number(valB) - Number(valA);
      }

      return direction === 'asc'
        ? String(valA).localeCompare(String(valB))
        : String(valB).localeCompare(String(valA));
    });

    setOrderedSales(sorted);
    dispatch(updateOrdersFiltered({ orders: sorted }));
  };

  const getColumnOptions = ({
    key,
    sort,
    parser,
    disabledHiddenOpt
  }: {
    key: keyof IOpenOrdersTableDataSource;
    sort: boolean;
    parser?: (val: any) => unknown;
    disabledHiddenOpt?: boolean;
  }) => {
    const options: TPanelOptions[] = [
      {
        text: 'Ordenar decrescente',
        handleOnClick: () => handleSort(key, 'desc', parser)
      },
      {
        text: 'Ordenar crescente',
        handleOnClick: () => handleSort(key, 'asc', parser)
      },
      {
        text: 'Ocultar este campo',
        disabled: !!disabledHiddenOpt,
        handleOnClick: () => {
          const futureDeliveriesColumn =
            getTargetKeyFromMap(key as string) || (key as string);

          const newPreferences = {
            ...orderPreferences,
            columnsHidden: [
              ...orderPreferences.columnsHidden,
              futureDeliveriesColumn
            ]
          };
          setOrderPreferences(newPreferences);
          debounceSavePreferences(newPreferences);
        }
      }
    ];
    return sort ? options : options.slice(2);
  };

  const handleDownloadNFE = (
    item: SalesOrderItemTable,
    selectedItems?: SalesOrderItemTable[]
  ) => {
    const activeTabState = ordersState[ordersState.tableType || EOrderTab.OPEN];
    const { startDate, endDate, states, emitterIds } =
      activeTabState.initialInputValues;

    const billingsFromBilling = item.billing?.filter(
      (b) => b.canDownloadNF && !!b.danfeNumber
    );

    const billings: Billing[] = billingsFromBilling?.length
      ? billingsFromBilling
      : ([
          { danfeNumber: item.danfeNumber, invoiceNumber: item.invoiceNumber }
        ] as Billing[]);

    dispatch(loadNewNFFile({ billings }));

    if (selectedItems) {
      sendActionButtonTagging('Baixar 2ª via da nota fiscal', selectedItems);
    }
  };

  const handleAccessOrder = (salesOrder: number) => {
    if (!salesOrder || driverRef.current) {
      return null;
    }

    dispatch(
      loadOrderDetail({
        customerType: customerViewType,
        orderId: salesOrder,
        customerId:
          orderedSales.find((item) => Number(item.salesOrder) === salesOrder)
            ?.soldTo?.code ?? '',
        onSuccess: () =>
          history.push(
            `${EOrdersRoutes.LONG_STEEL_ORDERS}${ENewLongSteelOrdersRoutes.DETAILS}/${salesOrder}`
          )
      })
    );
  };

  const sendActionButtonTagging = (
    click: string,
    selectedItems?: SalesOrderItemTable[]
  ) => {
    if (selectedItems?.length == 1) {
      dispatch(
        sendTagging({
          event: 'acoes_tabela_pedidos',
          click: click,
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos',
          estado_emissor:
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.states.join(', '),
          emissor_pedido: customersState.customers
            .filter((item) =>
              ordersState[
                ordersState.tableType || EOrderTab.OPEN
              ].initialInputValues.emitterIds.includes(item.customerId)
            )
            .map((item) => item.name)
            .join(', '),
          data_inicio:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(
                  ordersState[ordersState.tableType || EOrderTab.OPEN]
                    .initialInputValues.startDate
                ).format('DD/MM/YYYY'),
          data_fim:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(
                  ordersState[ordersState.tableType || EOrderTab.OPEN]
                    .initialInputValues.endDate
                ).format('DD/MM/YYYY')
        })
      );
    }
  };

  const getColumns = () => {
    const columns = [
      ...(ordersState.tableType === EOrderTab.OPEN
        ? [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 96,
                    title: 'Nº da OV',
                    column: 'salesOrder',
                    value: `${filters.salesOrder}\n${filters.salesOrderItem}`,
                    options: getColumnOptions({
                      key: 'salesOrder',
                      sort: true,
                      parser: (val: string) => Number(val),
                      disabledHiddenOpt: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'salesOrder',
              render: (
                _: unknown,
                record: SalesOrderItemTable,
                index: number
              ) => (
                <TableCell
                  id={
                    index === 0 && ordersState.tableType === EOrderTab.OPEN
                      ? 'onboarding-first-ov'
                      : undefined
                  }
                >
                  <TableOrderNumberSelectable
                    onClick={() =>
                      handleAccessOrder(Number(record.item?.salesOrder))
                    }
                  >
                    {record.item?.salesOrder}
                  </TableOrderNumberSelectable>
                  <br />
                  <>Item {record.item?.salesOrderItem}</>
                </TableCell>
              )
            }
          ]
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 96,
                    title: 'Nº da nota fiscal',
                    column: 'invoiceNumber',
                    value: filters.invoiceNumber,
                    options: getColumnOptions({
                      key: 'invoiceNumber',
                      sort: true,
                      disabledHiddenOpt: false,
                      parser: (val: string) => Number(val)
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'invoiceNumber',
              render: (
                _: unknown,
                record: SalesOrderItemTable,
                index: number
              ) => {
                const canDownloadNF =
                  record.billing?.some(
                    (b) => b.canDownloadNF && !!b.danfeNumber
                  ) ||
                  (!!record.billingHistory?.canDownloadNF &&
                    !!record.invoiceNumber);

                return (
                  <TableCell>
                    {canDownloadNF ? (
                      <TableOrderNumberSelectable
                        onClick={() => handleDownloadNFE(record)}
                      >
                        {record.invoiceNumber}
                      </TableOrderNumberSelectable>
                    ) : (
                      record.invoiceNumber
                    )}
                  </TableCell>
                );
              }
            }
          ]),
      ...(ordersState.tableType === EOrderTab.OPEN
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 144,
                    title: 'Data do faturamento',
                    column: 'billingDate',
                    value: filters.itemBillingDate,
                    options: getColumnOptions({
                      key: 'itemBillingDate',
                      sort: true,
                      parser: (val: string) =>
                        val ? moment(val).toDate() : null
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'billingDate',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  {!record.itemBillingDate
                    ? '-'
                    : moment(record.itemBillingDate).format('DD/MM/YYYY')}
                </TableCell>
              )
            }
          ]),
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 192,
              title: 'Id. do pedido',
              column: 'customerOrder',
              value: filters.customerOrder,
              options: getColumnOptions({
                key: 'customerOrder',
                sort: true,
                disabledHiddenOpt: true
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'customerOrder',
        render: (customerOrder: string) => (
          <TableCell>{customerOrder}</TableCell>
        )
      },
      ...(orderPreferences.materialCode === 'sku'
        ? [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Código e descrição do material',
                    column: 'codeAndDescription',
                    value:
                      ordersState.tableType === EOrderTab.OPEN
                        ? `${filters.sku}\n${filters.materialDescription}`
                        : `${filters.billingHistory?.sku}\n${filters.billingHistory?.materialDescription}`,
                    options: getColumnOptions({
                      key: 'materialDescription',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'codeAndDescription',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  <b>
                    {(ordersState.tableType === EOrderTab.OPEN
                      ? record.item?.materialDescription
                      : record.item?.billingHistory?.materialDescription) ??
                      ' - '}
                  </b>
                  <br />
                  <>
                    {(ordersState.tableType === EOrderTab.OPEN
                      ? record.item?.sku
                      : record.item?.billingHistory?.sku) ?? ' - '}
                  </>
                </TableCell>
              )
            }
          ]
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 140,
                    title: 'Código interno e descrição do material',
                    column: 'codeAndDescription',
                    value:
                      ordersState.tableType === EOrderTab.OPEN
                        ? `${filters.customerSKU}\n${filters.materialDescription}`
                        : `${filters.billingHistory?.customerSKU}\n${filters.billingHistory?.materialDescription}`,
                    options: getColumnOptions({
                      key: 'codeAndDescription',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'codeAndDescription',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  <b>
                    {(ordersState.tableType === EOrderTab.OPEN
                      ? record.item?.materialDescription
                      : record.item?.billingHistory?.materialDescription) ??
                      ' - '}
                  </b>
                  <br />
                  <>
                    {(ordersState.tableType === EOrderTab.OPEN
                      ? record.item?.customerSKU
                      : record.item?.billingHistory?.customerSKU) ?? ' - '}
                  </>
                </TableCell>
              )
            }
          ]),
      ...(ordersState.tableType === EOrderTab.OPEN
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 96,
                    title: 'Qtd. faturada',
                    column: 'billedQuantity',
                    value: `${filters.quantities?.billedQuantity} ${filters.quantities?.billingMeasureUnit}`,
                    options: getColumnOptions({
                      key: 'billedQuantity',
                      sort: true,
                      parser: (val: string) => Number(val)
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'billedQuantity',
              render: (_: unknown, record: SalesOrderItemTable) => {
                const billedQty = (record.item?.quantities as any)
                  ?.billingQuantity as number | undefined;
                const billingMeasureUnit =
                  record.item?.quantities?.billingMeasureUnit;
                return (
                  <TableCell>
                    {billedQty
                      ? `${formatNumberWithLocale({
                          value: billedQty
                        })} ${billingMeasureUnit || ''}`
                      : '-'}
                  </TableCell>
                );
              }
            }
          ]),
      ...(ordersState.tableType === EOrderTab.OPEN
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 96,
                    title: 'Nº da OV',
                    column: 'salesOrder',
                    value: `${filters.billingHistory?.salesOrder}\n${filters.billingHistory?.salesOrderItem}`,
                    options: getColumnOptions({
                      key: 'salesOrder',
                      sort: true,
                      parser: (val: string) => Number(val),
                      disabledHiddenOpt: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'salesOrder',
              render: (
                _: unknown,
                record: SalesOrderItemTable,
                index: number
              ) => (
                <TableCell
                  id={
                    index === 0 && ordersState.tableType === EOrderTab.BILLED
                      ? 'onboarding-first-ov'
                      : undefined
                  }
                >
                  <TableOrderNumberSelectable
                    onClick={() =>
                      handleAccessOrder(
                        Number(record.item?.billingHistory?.salesOrder)
                      )
                    }
                  >
                    {record.item?.billingHistory?.salesOrder}
                  </TableOrderNumberSelectable>
                  <br />
                  <>Item {record.item?.billingHistory?.salesOrderItem}</>
                </TableCell>
              )
            }
          ]),
      ...(ordersState.tableType === EOrderTab.OPEN
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 108,
                    title: 'Data do vencimento',
                    column: 'dueDate',
                    value: filters.dueDate,
                    options: getColumnOptions({
                      key: 'dueDate',
                      sort: true,
                      parser: (val: string[]) =>
                        val && val.length > 0 ? moment(val[0]).toDate() : null
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'dueDate',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  {record.dueDate?.length > 0 && record.dueDate[0]
                    ? moment(record.dueDate[0]).format('DD/MM/YYYY')
                    : '-'}
                </TableCell>
              )
            }
          ]),
      ...(ordersState.tableType === EOrderTab.BILLED
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Status do pedido',
                    column: 'orderStatus',
                    value: filters.futureDeliveriesTable,
                    options: getColumnOptions({
                      key: 'orderStatus',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'orderStatus',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <ProgressVolumeBar
                  requestedSubtitle="Qtd. solicitada:"
                  billed={{
                    quantity: Number(
                      record.item?.quantities?.billedConversionQuantity || 0
                    ),
                    measureUnit: 'T'
                  }}
                  delivery={{
                    quantity: Number(
                      record.item?.quantities?.deliveryConversionQuantity || 0
                    ),
                    measureUnit: 'T'
                  }}
                  pending={{
                    quantity: Number(
                      record.item?.quantities?.pendingConversionQuantity || 0
                    ),
                    measureUnit: 'T'
                  }}
                  requested={{
                    quantity: Number(
                      record.item?.quantities?.requestedConversionQuantity || 0
                    ),
                    measureUnit: 'T'
                  }}
                  shipment={{
                    quantity: Number(
                      record.item?.quantities?.shipmentConversionQuantity || 0
                    ),
                    measureUnit: 'T'
                  }}
                />
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 108,
                    title: 'Data desejada',
                    column: 'requestedDateTable',
                    value: filters.requestedDateTable,
                    options: getColumnOptions({
                      key: 'requestedDateTable',
                      sort: true,
                      parser: (val: string | undefined) =>
                        val ? moment(val, 'DD/MM/YYYY').toDate() : null
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'requestedDateTable',
              render: (requestedDateTable: string) => (
                <TableCell>{requestedDateTable}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 180,
                    title: 'Próxima data estimada',
                    column: 'nextEstimatedDate',
                    value: filters['nextFutureDeliveryQuantity'],
                    options: getColumnOptions({
                      key: 'nextFutureDeliveryMinDate',
                      sort: true,
                      parser: (val: string | undefined) =>
                        val ? moment(val, 'DD/MM/YYYY').toDate() : null
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'nextEstimatedDate',
              render: (_: unknown, record: SalesOrderItemTable) =>
                !record.futureDeliveries ||
                record.futureDeliveries.length === 0 ? (
                  <TableCell> - </TableCell>
                ) : (
                  <TableCell>
                    <b>
                      {record.futureDeliveries[0]?.estimatedDeliveryQuantity
                        ? parseFloat(
                            record.futureDeliveries[0].estimatedDeliveryQuantity
                          ).toLocaleString('pt-BR', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          })
                        : ''}{' '}
                      {record.futureDeliveries[0]
                        ?.estimatedDeliveryMeasureUnit ?? ''}
                    </b>{' '}
                    de{' '}
                    {record.futureDeliveries[0]?.estimatedDeliveryDate ?? '?'}
                  </TableCell>
                )
            }
          ]),
      ...(ordersState.tableType === EOrderTab.BILLED ||
      !orderedSales.some((item) => item.orderType === EOrderType.PLANOS)
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Status de produção de aços planos',
                    column: 'productionStatus',
                    value: filters.productionStatus,
                    options: getColumnOptions({
                      key: 'productionStatus',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'productionStatus',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <ProductionProgressVolumeBar
                  requestedSubtitle="Qtd. solicitada:"
                  meltShop={{
                    quantity: Number(record?.flatSteelProduction?.meltShop),
                    measureUnit: record?.flatSteelProduction?.unitMeasure || 'T'
                  }}
                  rollingMill={{
                    quantity: Number(record?.flatSteelProduction?.rollingMill),
                    measureUnit: record?.flatSteelProduction?.unitMeasure || 'T'
                  }}
                  rollingFinish={{
                    quantity: Number(
                      record?.flatSteelProduction?.rollingFinish
                    ),
                    measureUnit: record?.flatSteelProduction?.unitMeasure || 'T'
                  }}
                  finish={{
                    quantity: Number(record?.flatSteelProduction?.finish),
                    measureUnit: record?.flatSteelProduction?.unitMeasure || 'T'
                  }}
                  stockMill={{
                    quantity: Number(record?.flatSteelProduction?.stockMill),
                    measureUnit: record?.flatSteelProduction?.unitMeasure || 'T'
                  }}
                  transit={{
                    quantity: Number(record?.flatSteelProduction?.transit),
                    measureUnit: record?.flatSteelProduction?.unitMeasure || 'T'
                  }}
                  stockWarehouse={{
                    quantity: Number(
                      record?.flatSteelProduction?.stockWarehouse
                    ),
                    measureUnit: record?.flatSteelProduction?.unitMeasure || 'T'
                  }}
                  requested={{
                    quantity: Number(
                      record?.flatSteelProduction?.requestedQuantity
                    ),
                    measureUnit:
                      record?.flatSteelProduction
                        ?.requestedQuantityUnitMeasure || 'T'
                  }}
                  billed={{
                    quantity: Number(
                      record?.flatSteelProduction?.billedQuantity
                    ),
                    measureUnit:
                      record?.flatSteelProduction
                        ?.requestedQuantityUnitMeasure || 'T'
                  }}
                />
              )
            }
          ]),
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 128,
              title: 'Emissor',
              column: 'emitter',
              value: filters.emitter,
              options: getColumnOptions({
                key: 'emitter',
                sort: true
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'emitter',
        render: (_: string, record: SalesOrderItemTable) => (
          <TableCell>
            <TableOrderEmitterDescription>
              {record.emitter}
            </TableOrderEmitterDescription>
            <br />
            {record.emitterCode}
          </TableCell>
        )
      },
      ...(ordersState.tableType === EOrderTab.OPEN
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 96,
                    title: 'Nº da fatura',
                    column: 'invoiceBillNumber',
                    value: filters.billingNumber,
                    options: getColumnOptions({
                      key: 'invoiceBillNumber',
                      sort: true,
                      parser: (val: string) => Number(val)
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'invoiceBillNumber',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>{record.billingNumber || '-'}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 96,
                    title: 'Nº da nota de remessa',
                    column: 'shippingNoteNumber',
                    value: filters.deliveryCode,
                    options: getColumnOptions({
                      key: 'shippingNoteNumber',
                      sort: true,
                      parser: (val: string) => Number(val)
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'shippingNoteNumber',
              render: (_: unknown, record: SalesOrderItemTable) => {
                const canDownloadShipping =
                  !!record.deliveryDocumentZvoi ||
                  record.billing?.some((b) => !!b.deliveryDocumentZvoi) ||
                  !!record.invoiceZvoi;
                return (
                  <TableCell>
                    {canDownloadShipping ? (
                      <TableOrderNumberSelectable
                        onClick={() =>
                          dispatch(loadNewShippingNoteFile([record]))
                        }
                      >
                        {record.invoiceZvoi ||
                          record.deliveryDocumentZvoi ||
                          '-'}
                      </TableOrderNumberSelectable>
                    ) : (
                      record.invoiceZvoi || record.deliveryDocumentZvoi || '-'
                    )}
                  </TableCell>
                );
              }
            }
          ]),
      ...(orderPreferences.materialCode === 'sku'
        ? [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 147,
                    title: 'Código do material',
                    column: 'sku',
                    value:
                      ordersState.tableType === EOrderTab.OPEN
                        ? filters.sku
                        : filters.billingHistory?.sku,
                    options: getColumnOptions({
                      key: 'sku',
                      sort: true,
                      parser: (val: string) => Number(val)
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'sku',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  {(ordersState.tableType === EOrderTab.OPEN
                    ? record.item?.sku
                    : record.item?.billingHistory?.sku) ?? ' - '}
                </TableCell>
              )
            }
          ]
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 140,
                    title: 'Código interno',
                    column: 'customerSKU',
                    value:
                      ordersState.tableType === EOrderTab.OPEN
                        ? filters.customerSKU
                        : filters.billingHistory?.customerSKU,
                    options: getColumnOptions({
                      key: 'customerSKU',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'customerSKU',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  {(ordersState.tableType === EOrderTab.OPEN
                    ? record.item?.customerSKU
                    : record.item?.billingHistory?.customerSKU) ?? ' - '}
                </TableCell>
              )
            }
          ]),
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 256,
              title: 'Descrição do material',
              column: 'materialDescription',
              value:
                ordersState.tableType === EOrderTab.OPEN
                  ? filters.materialDescription
                  : filters.billingHistory?.materialDescription,
              options: getColumnOptions({
                key: 'materialDescription',
                sort: true
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'materialDescription',
        render: (_: unknown, record: SalesOrderItemTable) => (
          <TableCell>
            {(ordersState.tableType === EOrderTab.OPEN
              ? record.item?.materialDescription
              : record.item?.billingHistory?.materialDescription) ?? ' - '}
          </TableCell>
        )
      },
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 108,
              title: 'Data de criação',
              column: 'creationDateTable',
              value: filters.creationDateTable,
              options: getColumnOptions({
                key: 'creationDateTable',
                sort: true,
                parser: (val: string | undefined) =>
                  val ? moment(val, 'DD/MM/YYYY').toDate() : null
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'creationDateTable',
        render: (creationDateTable: string) => (
          <TableCell>{creationDateTable}</TableCell>
        )
      },
      ...(ordersState.tableType === EOrderTab.BILLED
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 220,
                    title: 'Status da entrega',
                    column: 'deliveryStatus',
                    value: filters.futureDeliveriesTable,
                    options: getColumnOptions({
                      key: 'deliveryStatus',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'deliveryStatus',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <DeliveryStatusColumn
                  data={record.futureDeliveriesTable ?? ''}
                />
              )
            }
          ]),
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 128,
              title: 'Recebedor',
              column: 'receiver',
              value: filters.receiver,
              options: getColumnOptions({
                key: 'receiver',
                sort: true
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'receiver',
        render: (name: string, record: SalesOrderItemTable) => (
          <TableCell>
            <TableOrderEmitterDescription>{name}</TableOrderEmitterDescription>
            <br />
            {record.receiverCode}
          </TableCell>
        )
      },
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 96,
              title: 'Nº do item',
              column: 'salesOrderItem',
              value: filters.salesOrderItem,
              options: getColumnOptions({
                key: 'salesOrderItem',
                sort: true,
                parser: (val: string) => Number(val)
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'salesOrderItem',
        render: (_: unknown, record: SalesOrderItemTable) => (
          <TableCell>
            {ordersState.tableType === EOrderTab.OPEN
              ? record.item?.salesOrderItem
              : record.item?.billingHistory?.salesOrderItem}
          </TableCell>
        )
      },
      // Essa informação não existe no momento
      // Não há número do pedido. apenas OVs
      // {
      //   title: (
      //     <HeaderColumnTable
      //       {...{
      //         width: 192,
      //         title: 'Número do pedido',
      //         column: 'numberOrder',
      //         value: filters.numberOrder,
      //         options: getColumnOptions({
      //           key: 'numberOrder',
      //           sort: true,
      //           parser: (val: string) => Number(val)
      //         }),
      //         debounce: (e) => debounceFilter(e),
      //         showFilter: false
      //       }}
      //     />
      //   ),
      //   dataIndex: 'numberOrder',
      //   render: (numberOrder: string) => <TableCell>{numberOrder}</TableCell>
      // },
      ...(ordersState.tableType === EOrderTab.BILLED
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Tipo de produto',
                    column: 'divisionDescription',
                    value: filters.divisionDescription,
                    options: getColumnOptions({
                      key: 'divisionDescription',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'divisionDescription',
              render: (divisionDescription: string) => (
                <TableCell>{divisionDescription}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Quantidade solicitada',
                    column: 'totalQuantityRequested',
                    value: filters.totalQuantityRequested,
                    options: getColumnOptions({
                      key: 'totalQuantityRequested',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'totalQuantityRequested',
              render: (totalQuantityRequested: string) => (
                <TableCell>{totalQuantityRequested}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Quantidade confirmada',
                    column: 'totalQuantityConfirmed',
                    value: filters.totalQuantityConfirmed,
                    options: getColumnOptions({
                      key: 'totalQuantityConfirmed',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'totalQuantityConfirmed',
              render: (totalQuantityConfirmed: string) => (
                <TableCell>{totalQuantityConfirmed}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Saldo',
                    column: 'totalQuantityPending',
                    value: filters.totalQuantityPending,
                    options: getColumnOptions({
                      key: 'totalQuantityPending',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'totalQuantityPending',
              render: (totalQuantityPending: string) => (
                <TableCell>{totalQuantityPending}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Em remessa',
                    column: 'totalQuantityDelivery',
                    value: filters.totalQuantityDelivery,
                    options: getColumnOptions({
                      key: 'totalQuantityDelivery',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'totalQuantityDelivery',
              render: (totalQuantityDelivery: string) => (
                <TableCell>{totalQuantityDelivery}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Em carregamento',
                    column: 'totalQuantityShipment',
                    value: filters.totalQuantityShipment,
                    options: getColumnOptions({
                      key: 'totalQuantityShipment',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'totalQuantityShipment',
              render: (totalQuantityShipment: string) => (
                <TableCell>{totalQuantityShipment}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Faturado',
                    column: 'totalQuantityBilled',
                    value: filters.totalQuantityBilled,
                    options: getColumnOptions({
                      key: 'totalQuantityBilled',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'totalQuantityBilled',
              render: (totalQuantityBilled: string) => (
                <TableCell>{totalQuantityBilled}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Aciaria',
                    column: 'meltShop',
                    value: String(filters.meltShop),
                    options: getColumnOptions({
                      key: 'meltShop',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'meltShop',
              render: (meltShop: string) => <TableCell>{meltShop}</TableCell>
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Laminação',
                    column: 'rollingMill',
                    value: String(filters.rollingMill),
                    options: getColumnOptions({
                      key: 'rollingMill',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'rollingMill',
              render: (rollingMill: string) => (
                <TableCell>{rollingMill}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'LA',
                    column: 'rollingFinish',
                    value: String(filters.rollingFinish),
                    options: getColumnOptions({
                      key: 'rollingFinish',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'rollingFinish',
              render: (rollingFinish: string) => (
                <TableCell>{rollingFinish}</TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Acabamento',
                    column: 'finish',
                    value: String(filters.finish),
                    options: getColumnOptions({
                      key: 'finish',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'finish',
              render: (finish: string) => <TableCell>{finish}</TableCell>
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Estoque Usina',
                    column: 'stockMill',
                    value: String(filters.stockMill),
                    options: getColumnOptions({
                      key: 'stockMill',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'stockMill',
              render: (stockMill: string) => <TableCell>{stockMill}</TableCell>
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Em transferência',
                    column: 'transit',
                    value: String(filters.transit),
                    options: getColumnOptions({
                      key: 'transit',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'transit',
              render: (transit: string) => <TableCell>{transit}</TableCell>
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 160,
                    title: 'Estoque entre-posto',
                    column: 'stockWarehouse',
                    value: String(filters.stockWarehouse),
                    options: getColumnOptions({
                      key: 'stockWarehouse',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'stockWarehouse',
              render: (stockWarehouse: string) => (
                <TableCell>{stockWarehouse}</TableCell>
              )
            }
          ]),
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 160,
              title: 'Condição de pagamento',
              column: 'paymentCondition',
              value: filters.conditions?.paymentTermsDescription,
              options: getColumnOptions({
                key: 'paymentCondition',
                sort: true
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'paymentCondition',
        render: (_: unknown, record: SalesOrderItemTable) => (
          <TableCell>
            {record.item?.conditions?.paymentTermsDescription ||
              (record.item?.billing &&
                record.item.billing.length > 0 &&
                record.item.billing[0]?.paymentTermsDescription) ||
              'Indisponível'}
          </TableCell>
        )
      },
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 96,
              title: 'Preço unitário c/ impostos',
              column: 'unitPriceTax',
              value: filters.conditions?.unitPriceWithTaxes,
              options: getColumnOptions({
                key: 'unitPriceTax',
                sort: true
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'unitPriceTax',
        render: (_: unknown, record: SalesOrderItemTable) => {
          const unitPriceTax = record.item?.conditions?.unitPriceWithTaxes;
          return (
            <TableCell>
              {isNaN(Number(unitPriceTax))
                ? 'Indisponível'
                : `R$ ${formatNumberWithLocale({
                    value: Number(unitPriceTax)
                  })}`}
            </TableCell>
          );
        }
      },
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 96,
              title: 'Preço unitário s/ impostos',
              column: 'unitPriceNoTax',
              value: filters.conditions?.unitPriceWithoutTaxes,
              options: getColumnOptions({
                key: 'unitPriceNoTax',
                sort: true
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'unitPriceNoTax',
        render: (_: unknown, record: SalesOrderItemTable) => {
          const unitPriceNoTax = record.item?.conditions?.unitPriceWithoutTaxes;
          return (
            <TableCell>
              {isNaN(Number(unitPriceNoTax))
                ? 'Indisponível'
                : `R$ ${formatNumberWithLocale({
                    value: Number(unitPriceNoTax)
                  })}`}
            </TableCell>
          );
        }
      },
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 96,
              title: 'Preço total c/ impostos',
              column: 'totalPriceTax',
              value: filters.conditions?.totalValueWithTaxes,
              options: getColumnOptions({
                key: 'totalPriceTax',
                sort: true
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'totalPriceTax',
        render: (_: unknown, record: SalesOrderItemTable) => {
          const isFullyBilled =
            Number(record.item?.quantities?.pendingConversionQuantity || 0) <=
              0 &&
            Number(record.item?.quantities?.billedConversionQuantity || 0) > 0;
          const totalPriceTax = isFullyBilled
            ? record.item?.conditions?.invoiceTotalValueWithTaxes
            : record.item?.conditions?.totalValueWithTaxes;
          return (
            <TableCell>
              {isNaN(Number(totalPriceTax))
                ? 'Indisponível'
                : `R$ ${formatNumberWithLocale({
                    value: Number(totalPriceTax)
                  })}`}
            </TableCell>
          );
        }
      },
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 96,
              title: 'Preço total s/ impostos',
              column: 'totalPriceNoTax',
              value: filters.conditions?.totalValueWithoutTaxes,
              options: getColumnOptions({
                key: 'totalPriceNoTax',
                sort: true
              }),
              debounce: (e) => debounceFilter(e),
              showFilter: false
            }}
          />
        ),
        dataIndex: 'totalPriceNoTax',
        render: (_: unknown, record: SalesOrderItemTable) => {
          const isFullyBilled =
            Number(record.item?.quantities?.pendingConversionQuantity || 0) <=
              0 &&
            Number(record.item?.quantities?.billedConversionQuantity || 0) > 0;
          const totalPriceNoTax = isFullyBilled
            ? record.item?.conditions?.invoiceTotalValueWithoutTaxes
            : record.item?.conditions?.totalValueWithoutTaxes;
          return (
            <TableCell>
              {isNaN(Number(totalPriceNoTax))
                ? 'Indisponível'
                : `R$ ${formatNumberWithLocale({
                    value: Number(totalPriceNoTax)
                  })}`}
            </TableCell>
          );
        }
      },
      ...(ordersState.tableType === EOrderTab.OPEN
        ? []
        : [
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 96,
                    title: 'Total da fatura c/ impostos',
                    column: 'invoiceTotalTax',
                    value: filters.conditions?.invoiceTotalValueWithTaxes,
                    options: getColumnOptions({
                      key: 'invoiceTotalTax',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'invoiceTotalTax',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  {isNaN(
                    Number(record.item?.conditions?.invoiceTotalValueWithTaxes)
                  )
                    ? 'Indisponível'
                    : `R$ ${formatNumberWithLocale({
                        value: Number(
                          record.item?.conditions?.invoiceTotalValueWithTaxes
                        )
                      })}`}
                </TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 96,
                    title: 'Total da fatura s/ impostos',
                    column: 'invoiceTotalNoTax',
                    value: filters.conditions?.invoiceTotalValueWithoutTaxes,
                    options: getColumnOptions({
                      key: 'invoiceTotalNoTax',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'invoiceTotalNoTax',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  {isNaN(
                    Number(
                      record.item?.conditions?.invoiceTotalValueWithoutTaxes
                    )
                  )
                    ? 'Indisponível'
                    : `R$ ${formatNumberWithLocale({
                        value: Number(
                          record.item?.conditions?.invoiceTotalValueWithoutTaxes
                        )
                      })}`}
                </TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 200,
                    title: 'Chave de acesso da NF',
                    column: 'accessKey',
                    value: '',
                    options: getColumnOptions({
                      key: 'accessKey',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'accessKey',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  {record.nfeAccessKey || record.item?.nfeAccessKey || '-'}
                </TableCell>
              )
            },
            {
              title: (
                <HeaderColumnTable
                  {...{
                    width: 128,
                    title: 'Corrida',
                    column: 'heatNumber',
                    value: '',
                    options: getColumnOptions({
                      key: 'heatNumber',
                      sort: true
                    }),
                    debounce: (e) => debounceFilter(e),
                    showFilter: false
                  }}
                />
              ),
              dataIndex: 'heatNumber',
              render: (_: unknown, record: SalesOrderItemTable) => (
                <TableCell>
                  {record.productionBatch ||
                    record.item?.productionBatch ||
                    '-'}
                </TableCell>
              )
            }
          ]),
      ...(ordersState.tableType === EOrderTab.BILLED
        ? []
        : futureDeliveriesColumnQty > 0
        ? Array.from({ length: futureDeliveriesColumnQty })
            .map((_, index) => [
              {
                title: (
                  <HeaderColumnTable
                    {...{
                      width: 200,
                      title: `Data estimada - ${index + 1}`,
                      column: `futureDelivery_${index}_date`,
                      value: filters[`futureDelivery_${index}_date`],
                      options: getColumnOptions({
                        key: `futureDelivery_${index}_date`,
                        sort: true,
                        parser: (val: string | undefined) =>
                          val ? moment(val, 'DD/MM/YYYY').toDate() : null
                      }),
                      debounce: (e) => debounceFilter(e),
                      showFilter: false
                    }}
                  />
                ),
                dataIndex: `futureDelivery_${index}_date`,
                render: (value: string) => <TableCell>{value ?? '-'}</TableCell>
              },
              {
                title: (
                  <HeaderColumnTable
                    {...{
                      width: 180,
                      title: `Qtd. entrega - ${index + 1}`,
                      column: `futureDelivery_${index}_quantity`,
                      value: filters[`futureDelivery_${index}_quantity`],
                      options: getColumnOptions({
                        key: `futureDelivery_${index}_quantity`,
                        sort: true
                      }),
                      debounce: (e) => debounceFilter(e),
                      showFilter: false
                    }}
                  />
                ),
                dataIndex: `futureDelivery_${index}_quantity`,
                render: (value: string) => <TableCell>{value ?? '-'}</TableCell>
              },
              {
                title: (
                  <HeaderColumnTable
                    {...{
                      width: 180,
                      title: `Un. entrega - ${index + 1}`,
                      column: `futureDelivery_${index}_unit`,
                      value: filters[`futureDelivery_${index}_unit`],
                      options: getColumnOptions({
                        key: `futureDelivery_${index}_unit`,
                        sort: true
                      }),
                      debounce: (e) => debounceFilter(e),
                      showFilter: false
                    }}
                  />
                ),
                dataIndex: `futureDelivery_${index}_unit`,
                render: (value: string) => <TableCell>{value ?? '-'}</TableCell>
              }
            ])
            .flatMap((item) => item)
        : []),
      {
        title: (
          <HeaderColumnTable
            {...{
              width: 92,
              title: 'Ações',
              column: 'actions',
              value: 'actions',
              debounce: () => null,
              showFilter: false
            }}
          />
        ),
        dataIndex: 'key',
        render: (key: string) => {
          const isRowActionDisabled = selectedRowKeys.length > 0;
          return isRowActionDisabled ? (
            <Button
              name="action-information-panel"
              variant="neutral"
              icon={<Icon option="MoreVertical"></Icon>}
              disabled
            >
              Ações
            </Button>
          ) : (
            <InformationPanel
              panelWidth="288"
              trigger={
                <div>
                  <Button
                    name="action-information-panel"
                    variant="neutral"
                    icon={<Icon option="MoreVertical"></Icon>}
                    onClick={() => sendActionButtonTagging('Ações')}
                  >
                    Ações
                  </Button>
                </div>
              }
              position="bottom right"
              panelOptions={panelOptions({ orderKey: key })}
            />
          );
        }
      }
    ];

    return columns
      .filter((col) => !finalHideColumns.includes(col.dataIndex))
      .map((item, index, arr) => {
        if (
          (index === arr.length - 1 || index === arr.length - 2) &&
          React.isValidElement(item.title)
        ) {
          return {
            ...item,
            title: React.cloneElement(
              item.title as React.ReactElement<HeaderColumnProps>,
              {
                lastColumns: true
              }
            )
          };
        }
        return item;
      });
  };

  const dispatchMaxRowsToast = () =>
    dispatch(
      addToast({
        type: EToastTypes.WARNING,
        message: 'Máximo de 10 itens por seleção atingido.',
        durationInMS: 5000,
        labelActionOne: 'Fechar'
      })
    );

  const rowSelection: TableRowSelection<SalesOrderItemTable> = {
    selectedRowKeys,
    type: 'checkbox',
    onSelectAll: (selected, _selectedRows, changeRows) => {
      if (!selected) {
        setSelectedRowKeys([]);
        return;
      }

      if (selectedRowKeys.length >= maxSelectedRows) {
        setSelectedRowKeys([]);
        return;
      }

      const eligibleRows = changeRows.filter(
        (row) =>
          row.orderType !== EOrderType.PLANOS &&
          !selectedRowKeys.includes(row.key)
      );

      const remainingCapacity = Math.max(
        0,
        maxSelectedRows - selectedRowKeys.length
      );
      const newKeysToSelect = eligibleRows
        .slice(0, remainingCapacity)
        .map((row) => row.key);

      const toSelect = [...selectedRowKeys, ...newKeysToSelect];

      if (toSelect.length >= maxSelectedRows && newKeysToSelect.length > 0) {
        dispatchMaxRowsToast();
      }

      setSelectedRowKeys(toSelect);
    },
    onChange: (e, _selectedRows, info) => {
      if (info.type === 'all') {
        return;
      }

      if (e.length > maxSelectedRows) {
        dispatchMaxRowsToast();
        return;
      }

      if (e.length === maxSelectedRows) {
        dispatchMaxRowsToast();
      }

      setSelectedRowKeys(e);
    },
    preserveSelectedRowKeys: true,
    renderCell: (_value, record, _index, originNode) => {
      return record.orderType === EOrderType.PLANOS ? (
        <Tooltip
          title="Esse item não pode ser selecionado no momento. Consulte o seu vendedor."
          placement="right"
        >
          <div>{originNode}</div>
        </Tooltip>
      ) : (
        <>{originNode}</>
      );
    },
    getCheckboxProps: (record) => ({
      disabled: record.orderType === EOrderType.PLANOS
    })
  };

  const panelOptions = ({ orderKey = '' }: { orderKey?: string } = {}) => {
    const selectedItems = orderedSales.filter(
      (order) => selectedRowKeys.includes(order.key) || order.key === orderKey
    );
    const firstItem = selectedItems[0];

    const handleAction = (type: 'cancel' | 'update') => {
      if (selectedItems.length > 0) {
        dispatch(
          validationUpdateItems({
            itemsSelected: selectedItems,
            typeAction: type
          })
        );

        sendActionButtonTagging(
          type == 'cancel' ? 'Solicitar cancelamento' : 'Solicitar alterações',
          selectedItems
        );

        dispatch(
          sendTagging({
            event:
              type == 'cancel'
                ? 'solicitacao_cancelamento'
                : 'solicitar_alteracoes',
            click: type == 'cancel' ? 'cancelar' : 'solicitar_alteracoes',
            screenName: 'LG:MeusPedidos',
            itemDescription: 'meus_pedidos_acosLongos',
            estado_emissor:
              ordersState[
                ordersState.tableType || EOrderTab.OPEN
              ].initialInputValues.states.join(', '),
            emissor_pedido: customersState.customers
              .filter((item) =>
                ordersState[
                  ordersState.tableType || EOrderTab.OPEN
                ].initialInputValues.emitterIds.includes(item.customerId)
              )
              .map((item) => item.name)
              .join(', '),
            data_inicio:
              ordersState.tableType === EOrderTab.OPEN
                ? undefined
                : moment(
                    ordersState[ordersState.tableType || EOrderTab.OPEN]
                      .initialInputValues.startDate
                  ).format('DD/MM/YYYY'),
            data_fim:
              ordersState.tableType === EOrderTab.OPEN
                ? undefined
                : moment(
                    ordersState[ordersState.tableType || EOrderTab.OPEN]
                      .initialInputValues.endDate
                  ).format('DD/MM/YYYY')
          })
        );
      }
    };

    const handleDownload = (tagName = 'baixar_documentos') => {
      if (selectedItems.length > 0) {
        dispatch(downloadOrderItems({ downloadsItemsSelected: selectedItems }));
        history.push(
          `${ERoutes.ORDERS}/${EPurchaseRoutes.LONG_STEEL}?downloads`
        );
        sendActionButtonTagging(
          'Mostrar documentos disponíveis',
          selectedItems
        );
      }
    };

    const isPlanosType = selectedItems.every(
      (item) => item.orderType === EOrderType.PLANOS
    );

    const isDownloadDisabled = selectedItems.every((item) => {
      const hasData = item.billing?.length > 0 || !!item.billingHistory;
      if (!hasData || selectedRowKeys.length > 1) return true;

      const hasInvoices =
        item.billing?.some(
          (b) => b.canDownloadNF || b.canDownloadQC || b.invoiceZvoi
        ) ||
        item.billingHistory?.canDownloadNF ||
        item.billingHistory?.canDownloadQC ||
        item.invoiceZvoi;

      return !hasInvoices;
    });

    const isBilledMultipleSelection =
      ordersState.tableType === EOrderTab.BILLED && selectedItems.length > 1;

    return actionsOptions({
      ...(ordersState.tableType === EOrderTab.OPEN && {
        onCancelOrderClick: () => handleAction('cancel'),
        onUpdateOrderClick: () => handleAction('update')
      }),

      ...(orderKey && {
        onViewOrderClick: () => {
          if (firstItem?.salesOrder)
            handleAccessOrder(Number(firstItem.salesOrder));
          sendActionButtonTagging('Abrir ordem de venda', selectedItems);
        },
        downloadOrderTitle: 'Mostrar documentos disponíveis'
      }),

      ...((ordersState.tableType === EOrderTab.BILLED || orderKey) && {
        onDownloadOrderClick: () => handleDownload()
      }),
      ...(ordersState.tableType === EOrderTab.BILLED && {
        onDownloadNFE: () => handleDownloadNFE(firstItem, selectedItems),
        onDownloadShippingNFE: () => {
          dispatch(loadNewShippingNoteFile([firstItem]));
        },
        onDownloadQC: () => {
          dispatch(loadNewQCFile([firstItem]));

          dispatch(
            sendTagging({
              event:
                selectedItems.length > 1
                  ? 'baixar_todos_certificados'
                  : 'baixar_certificado',
              pedido_id: firstItem.customerOrder,
              screenName: 'LG:MeusPedidos',
              itemDescription: 'meus_pedidos_acosLongos',
              estado_emissor:
                ordersState[
                  ordersState.tableType || EOrderTab.OPEN
                ].initialInputValues.states.join(', '),
              emissor_pedido: customersState.customers
                .filter((item) =>
                  ordersState[
                    ordersState.tableType || EOrderTab.OPEN
                  ].initialInputValues.emitterIds.includes(item.customerId)
                )
                .map((item) => item.name)
                .join(', '),
              data_inicio:
                ordersState.tableType === EOrderTab.OPEN
                  ? undefined
                  : moment(
                      ordersState[ordersState.tableType || EOrderTab.OPEN]
                        .initialInputValues.startDate
                    ).format('DD/MM/YYYY'),
              data_fim:
                ordersState.tableType === EOrderTab.OPEN
                  ? undefined
                  : moment(
                      ordersState[ordersState.tableType || EOrderTab.OPEN]
                        .initialInputValues.endDate
                    ).format('DD/MM/YYYY')
            })
          );

          sendActionButtonTagging(
            'Baixar certificados de qualidade',
            selectedItems
          );
        },
        onNFEAcessKey: async () => {
          if (firstItem?.nfeAccessKey) {
            await navigator.clipboard.writeText(firstItem.nfeAccessKey);
            window.open(
              `https://www.nfe.fazenda.gov.br/portal/consultaRecaptcha.aspx?tipoConsulta=completa&tipoConteudo=7PhJ+gAVw2g=&nfe=${firstItem?.nfeAccessKey}`,
              '_blank'
            );
            sendActionButtonTagging(
              'Abrir chave de acesso da NF',
              selectedItems
            );
          }
        },
        onDownloadXML: () => {
          if (firstItem?.billingNumber) {
            dispatch(loadXml(firstItem.billingNumber));
            sendActionButtonTagging('Baixar XML', selectedItems);
          }
        }
      }),

      disableDownloadOrderFn: isBilledMultipleSelection || isDownloadDisabled,
      disableCancelOrderFn: isBilledMultipleSelection || isPlanosType,
      disableUpdateOrderFn: isBilledMultipleSelection || isPlanosType,
      disableDownloadNFeOrderFn:
        isBilledMultipleSelection || !firstItem?.billingHistory?.canDownloadNF,
      disableDownloadShippingOrderFn:
        isBilledMultipleSelection ||
        !(
          !!firstItem?.deliveryDocumentZvoi ||
          firstItem?.billing?.some((b) => !!b.deliveryDocumentZvoi) ||
          !!firstItem?.invoiceZvoi
        ),
      disableDownloadQCOrderFn:
        isBilledMultipleSelection || !firstItem?.cqNumber,
      disableNFEAcessKeyOrderFn:
        isBilledMultipleSelection || !firstItem?.nfeAccessKey,
      disableDownloadXMLOrderFn:
        isBilledMultipleSelection || !firstItem?.billingNumber
    });
  };

  const tableCustomerIds = useMemo(() => {
    const ids = new Set<string>();
    orderedSales.forEach((order) => {
      if (order.shipTo?.code) {
        ids.add(order.shipTo.code);
      }
    });
    return Array.from(ids);
  }, [orderedSales]);

  const tableCustomers = useMemo(() => {
    const entriesFromOrderSale: TMinimalDescribeICustomer[] = orderedSales.map(
      (it) => ({
        customerId: it.shipTo.code,
        taxNumber: it.shipTo.taxNumber,
        name: it.shipTo.name,
        locality: {
          zipCode: it.shipTo.zipCode,
          state: it.shipTo.state,
          city: it.shipTo.city,
          address: it.shipTo.address,
          country: it.shipTo.country,
          district: it.shipTo.state,
          zipcode: it.shipTo.zipCode
        }
      })
    );
    const idsFromOrderSale = Array.from(
      new Set(orderedSales.map((it) => it.shipTo.code))
    );
    const filteredEntriesFromOrderSale = idsFromOrderSale.map(
      (id) =>
        entriesFromOrderSale.find(
          (it) => it.customerId === id
        ) as TMinimalDescribeICustomer
    );
    const mergedArray = [
      ...customers.filter((customer) =>
        tableCustomerIds.includes(customer.customerId)
      ),
      ...filteredEntriesFromOrderSale
    ];
    return Array.from(
      new Map(mergedArray.map((item) => [item.customerId, item])).values()
    );
  }, [customers, tableCustomerIds]);

  useEffect(() => {
    if (tableCustomers.length) {
      setReceiverIds(
        Array.from(new Set(tableCustomers.map((it) => it.customerId)))
      );
    }
  }, [tableCustomers.length]);

  if (
    !loadingState &&
    hasInitialized &&
    (!ordersItems || ordersItems?.length === 0)
  ) {
    return (
      <MessageChooseContract>
        <MessageWithoutEmitter>
          Nenhum pedido encontrado <br />
          para os filtros selecionados.
        </MessageWithoutEmitter>
      </MessageChooseContract>
    );
  }

  if (!hasInitialized) {
    return null;
  }

  const handleUpdatePreferences = (preferences: OrderPreferencesProps) => {
    const newToggles = orderViewPreferenceDefault.toggles.map((item) => {
      const isChecked = !preferences.columnsHidden.includes(item.value);

      return {
        value: item.value,
        checked: isChecked
      };
    });

    newToggles.push({
      value: 'chipState_customerSKU',
      checked: preferences.materialCode === 'customerSKU'
    });

    const newPreferences = {
      name: EUserPreferenceType.ORDER_VIEW,
      toggles: newToggles
    };

    const orderEntryIdx = user.preferences.findIndex(
      (preference) => preference.name === EUserPreferenceType.ORDER_VIEW
    );
    const hasPreferences = user.preferences[
      orderEntryIdx
    ] as IOrderViewPreference;

    const hasChanged =
      JSON.stringify(hasPreferences?.toggles) !==
      JSON.stringify(newPreferences?.toggles);

    if (hasChanged || !hasPreferences) {
      const saveUserProps: ISaveUser = {
        user: user,
        userPreference: newPreferences
      };
      dispatch(saveUser(saveUserProps));
    }

    const updatedColumnsHidden = newToggles
      .filter((item) => !item.checked)
      .map((item) => item.value);

    setOrderPreferences({
      columnsHidden: updatedColumnsHidden,
      materialCode: preferences.materialCode
    });

    setModal((prev) => ({ ...prev, personalizeTable: false }));

    const click = Object.keys(hasPreferences?.toggles || {})
      .filter(
        (key) =>
          hasPreferences?.toggles[Number(key)]?.checked !==
          newPreferences?.toggles[Number(key)]?.checked
      )
      .map((key) => newPreferences?.toggles?.[Number(key)]?.value)
      .map(
        (item) =>
          openOrderSections.flatMap((section) =>
            section.items
              .filter((subItem) => subItem.value === item)
              .map((subItem) => (item = subItem.label))
          )[0]
      )
      .join(', ');

    if (click) {
      dispatch(
        sendTagging({
          event: 'personalizar_campos_tabela',
          click: click,
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos',
          estado_emissor:
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.states.join(', '),
          emissor_pedido: customersState.customers
            .filter((item) =>
              ordersState[
                ordersState.tableType || EOrderTab.OPEN
              ].initialInputValues.emitterIds.includes(item.customerId)
            )
            .map((item) => item.name)
            .join(', '),
          data_inicio:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(
                  ordersState[ordersState.tableType || EOrderTab.OPEN]
                    .initialInputValues.startDate
                ).format('DD/MM/YYYY'),
          data_fim:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(
                  ordersState[ordersState.tableType || EOrderTab.OPEN]
                    .initialInputValues.endDate
                ).format('DD/MM/YYYY')
        })
      );
    }

    if (preferences.materialCode !== orderPreferences.materialCode) {
      dispatch(
        sendTagging({
          event: 'preferencia_cod_material',
          click:
            preferences.materialCode === 'sku'
              ? 'Selecionar código Gerdau'
              : 'Selecionar código interno',
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos',
          estado_emissor:
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.states.join(', '),
          emissor_pedido: customersState.customers
            .filter((item) =>
              ordersState[
                ordersState.tableType || EOrderTab.OPEN
              ].initialInputValues.emitterIds.includes(item.customerId)
            )
            .map((item) => item.name)
            .join(', '),
          data_inicio:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(
                  ordersState[ordersState.tableType || EOrderTab.OPEN]
                    .initialInputValues.startDate
                ).format('DD/MM/YYYY'),
          data_fim:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(
                  ordersState[ordersState.tableType || EOrderTab.OPEN]
                    .initialInputValues.endDate
                ).format('DD/MM/YYYY')
        })
      );
    }
  };

  const handleShowPersonalizeModal = () => {
    if (driverRef.current) {
      return null;
    }
    setModal((prev) => ({ ...prev, personalizeTable: true }));

    dispatch(
      sendTagging({
        event: 'personalizar_tabela',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(
                ordersState[ordersState.tableType || EOrderTab.OPEN]
                  .initialInputValues.startDate
              ).format('DD/MM/YYYY'),
        data_fim:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(
                ordersState[ordersState.tableType || EOrderTab.OPEN]
                  .initialInputValues.endDate
              ).format('DD/MM/YYYY')
      })
    );
  };

  const handleClosePersonalizeModal = () => {
    setModal((prev) => ({ ...prev, personalizeTable: false }));

    dispatch(
      sendTagging({
        event: 'modal_personalizar_tabela',
        click: 'Cancelar',
        screenName: 'LG:MeusPedidos',
        itemDescription: 'meus_pedidos_acosLongos',
        estado_emissor:
          ordersState[
            ordersState.tableType || EOrderTab.OPEN
          ].initialInputValues.states.join(', '),
        emissor_pedido: customersState.customers
          .filter((item) =>
            ordersState[
              ordersState.tableType || EOrderTab.OPEN
            ].initialInputValues.emitterIds.includes(item.customerId)
          )
          .map((item) => item.name)
          .join(', '),
        data_inicio:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(
                ordersState[ordersState.tableType || EOrderTab.OPEN]
                  .initialInputValues.startDate
              ).format('DD/MM/YYYY'),
        data_fim:
          ordersState.tableType === EOrderTab.OPEN
            ? undefined
            : moment(
                ordersState[ordersState.tableType || EOrderTab.OPEN]
                  .initialInputValues.endDate
              ).format('DD/MM/YYYY')
      })
    );
  };

  const onChangeStates = (states: string[]) => {
    const selectedCustomers = customers.filter((cust) =>
      emitterIds.includes(cust.customerId)
    );

    if (
      selectedCustomers.some((cust) => !states.includes(cust.locality.state))
    ) {
      setEmitterIds([]);
      setReceiverIds([]);
    }

    setSelectedStates(states);
  };

  const downloadExcel = async () => {
    if (driverRef.current) {
      return null;
    }
    try {
      let fileName = '';
      const startExportDate = activeTabState.initialInputValues.startDate;
      const endExportDate = activeTabState.initialInputValues.endDate;
      const startDateStr = moment(startExportDate).format('DD-MM-YYYY');
      const endDateStr = moment(endExportDate).format('DD-MM-YYYY');
      let tableContent = '';

      fileName =
        ordersState.tableType === EOrderTab.OPEN
          ? 'Pedidos_Abertos'
          : `Pedidos_Faturados_${startDateStr}_a_${endDateStr}`;
      const orders =
        activeTabState?.ordersFiltered &&
        activeTabState?.ordersFiltered?.length > 0
          ? activeTabState.ordersFiltered
          : (activeTabState.items as SalesOrderItemTable[]);

      const hasSomeFlatItem: boolean = orders.some(
        (item) => item.orderType === EOrderType.PLANOS
      );

      if (hasSomeFlatItem) {
        const orderSvc = new NewLongSteelOrdersService();
        const flatSteelItems = orders.filter(
          (item) => item.orderType === EOrderType.PLANOS
        );

        await orderSvc.getTrackingFlatSteelExcel(
          flatSteelItems,
          userState.searchCustomerType
        );
      }

      tableContent = createXMLTable(
        ReactDOMServer.renderToString(
          <OrderTableContentToExcel
            orders={
              orders as Partial<SalesOrderItemTable & SalesOrderItemTable>[]
            }
            hasSomeFlatItem={hasSomeFlatItem}
            tableType={ordersState.tableType}
          />
        ),
        fileName
      );

      const element = document.createElement('a');
      element.setAttribute(
        'href',
        'data:application/vnd.ms-excel,' + encodeURIComponent(tableContent)
      );
      element.setAttribute('download', fileName);
      element.style.display = 'none';
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
      MarketingCloudService.sendEvent({
        type: 'long-steel-orders',
        downloadExcel: true
      });
      // exportToXLSX(tableContent, fileName);

      dispatch(
        sendTagging({
          event: 'exportar_carteira',
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos',
          estado_emissor: activeTabState.initialInputValues.states.join(', '),
          emissor_pedido: customersState.customers
            .filter((item) =>
              activeTabState.initialInputValues.emitterIds.includes(
                item.customerId
              )
            )
            .map((item) => item.name)
            .join(', '),
          data_inicio:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(startExportDate).format('DD/MM/YYYY'),
          data_fim:
            ordersState.tableType === EOrderTab.OPEN
              ? undefined
              : moment(endExportDate).format('DD/MM/YYYY')
        })
      );
    } catch (error) {
      dispatch(
        sendTagging({
          event: 'erro_exportar_carteira',
          screenName: 'LG:MeusPedidos',
          itemDescription: 'meus_pedidos_acosLongos'
        })
      );
    }
  };

  return (
    <OrdersTableContainer>
      <TableHeaderContainer>
        <TableHeaderContainerButtons>
          <SearchField
            label="Busca"
            name="search-order-input"
            placeholder="Tipo de produto, código, descrição..."
            inputValue={query}
            onChange={(e) => {
              setQuery(e.target.value);
            }}
          />
          <EmitterAndReceiverSelector
            orderOrInvoiceState={orderState}
            customerViewType={ECustomerTypeView.RECEIVER}
            isUserAdmin={false}
            emitterIds={emitterIds}
            setEmitterIds={setEmitterIds}
            receiverIds={receiverIds}
            setReceiverIds={setReceiverIds}
            customers={tableCustomers}
            showCustomerStates={true}
            selectedStates={selectedStates}
            onChangeStates={onChangeStates}
            customersPlaceholder="Selecione"
            statesPlaceholder="Selecione"
            receiversPlaceholder="Selecione"
            onBlurReceivers={() => {
              dispatch(
                sendTagging({
                  event: 'click_recebedor',
                  recebedores: customers.filter((customer) =>
                    receiverIds.includes(customer.customerId)
                  ),
                  screenName: 'LG:MeusPedidos'
                })
              );
            }}
          />
          <Select
            label="Status do pedido"
            name={'dropdownCustomers'}
            value={selectedStatuses}
            options={orderStatus}
            isMultipleSelect={true}
            onBlur={() => {
              dispatch(
                sendTagging({
                  event: 'status_pedido',
                  status_pedido: selectedStatuses
                    .map(
                      (selectedStatus) =>
                        orderStatus.find(
                          (orderStatus) => orderStatus.value === selectedStatus
                        )?.label || selectedStatus
                    )
                    .join(', '),
                  screenName: 'LG:MeusPedidos'
                })
              );
            }}
            onSelect={(value: string | string[]) => {
              const newStatuses = Array.isArray(value) ? value : [value];
              if (ordersState.tableType === EOrderTab.BILLED) {
                setSelectedStatusesBilled(newStatuses);
              } else {
                setSelectedStatusesOpen(newStatuses);
              }
            }}
            placeholder="Selecione"
          />

          <TableHeaderRightActions>
            <Button
              id="onboarding-personalize-table"
              onClick={handleShowPersonalizeModal}
              name="personalize-table"
              variant="secondary"
            >
              Personalizar tabela
            </Button>
            <Button
              id="onboarding-download-xls"
              icon={<Icon option="XLS" />}
              onClick={downloadExcel}
              name="download-xls"
              variant="secondary"
            />
            <TableHeaderActionButton>
              <Button
                disabled={
                  selectedRowKeys.length === 0 ||
                  (orderState.tableType === EOrderTab.BILLED &&
                    selectedRowKeys.length > 1)
                }
                variant="secondary"
                name="actions-button"
              >
                <InformationPanel
                  trigger={
                    <div>
                      <Button
                        name="action-information-panel"
                        variant="neutral"
                        icon={<Icon option="MoreVertical"></Icon>}
                      />
                    </div>
                  }
                  position="bottom right"
                  panelOptions={panelOptions()}
                />
              </Button>
            </TableHeaderActionButton>
          </TableHeaderRightActions>
        </TableHeaderContainerButtons>
      </TableHeaderContainer>
      <TableContainer>
        <Table
          key={JSON.stringify(filterOrders.map((item) => item.key))}
          scroll={{ x: '300px' }}
          columns={getColumns()}
          data={filterOrders}
          rowSelection={rowSelection}
          hasPagination
        />
      </TableContainer>

      <OrdersPersonalizeModal
        tableType={ordersState.tableType}
        orderPreferences={orderPreferences}
        canShow={modal.personalizeTable}
        onClose={handleClosePersonalizeModal}
        onUpdate={handleUpdatePreferences}
        hasFlatsteel={orderedSales.some(
          (item) => item.orderType === EOrderType.PLANOS
        )}
        hasFutureDeliveries={futureDeliveriesColumnQty > 0}
      />
    </OrdersTableContainer>
  );
};
